// extracted by mini-css-extract-plugin
export default {"stepGetOffer":"StepGetOffer_stepGetOffer__IMUNU","item":"StepGetOffer_item__Yc6jq","active":"StepGetOffer_active__YBg82"};